/**
 * Patterns logger - wrapper around logging library
 *
 * Copyright 2012-2013 Florian Friesdorf
 */
define([
    'logging'
], function(logging) {
    var log = logging.getLogger('patterns');
    return log;
});



//////////////////
// WEBPACK FOOTER
// ./src/core/logger.js
// module id = 3
// module chunks = 0 1